import React from 'react';

import { ActionType } from '../../Types';

import './CartNotification.scss';

interface Props {
    latestAction: ActionType | null;
}

export default function CartNotificationUpdate(props: Props) {
    const visibilityClass = () => {
        if (props.latestAction === ActionType.Update) {
            return 'cart-notification--visible';
        }

        return '';
    };

    return (
        <div className={'cart-notification cart-notification--update ' + visibilityClass()}>
            <div className="cart-notification__icon">
                <svg className="icon">
                    <use xlinkHref="#icon-checkmark" />
                </svg>
            </div>
            <div className="cart-notification__text">Ein Artikel wurde im Warenkorb aktualisiert</div>
        </div>
    );
}
